import React from 'react';
import { Minus, Plus } from 'lucide-react';

export function Switch({ on, onChange }: { on: boolean; onChange: (v: boolean) => void }) {
  return (
    <button className={`switch ${on ? 'on' : ''}`} aria-pressed={on}
      style={{ background: on ? 'var(--primary)' : 'var(--fill)' }}
      onClick={() => onChange(!on)}>
      <span className="knob" />
    </button>
  );
}

export function Segmented<T extends string>({ value, options, onChange }: {
  value: T; options: { id: T; label: string }[]; onChange: (v: T) => void;
}) {
  return (
    <div className="seg">
      {options.map((o) => (
        <button key={o.id} className={value === o.id ? 'on' : ''} onClick={() => onChange(o.id)}>{o.label}</button>
      ))}
    </div>
  );
}

export function Stepper({ value, min, max, onChange }: { value: number; min: number; max: number; onChange: (v: number) => void }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2, background: 'var(--fill)', borderRadius: 9, padding: 3 }}>
      <button className="icon-btn" style={{ width: 28, height: 28, background: 'transparent' }} onClick={() => onChange(Math.max(min, value - 1))}><Minus size={15} /></button>
      <span style={{ minWidth: 26, textAlign: 'center', fontSize: 14, fontWeight: 600 }}>{value}</span>
      <button className="icon-btn" style={{ width: 28, height: 28, background: 'transparent' }} onClick={() => onChange(Math.min(max, value + 1))}><Plus size={15} /></button>
    </div>
  );
}

export function Sheet({ title, onClose, children, headerRight }: {
  title?: string; onClose: () => void; children: React.ReactNode; headerRight?: React.ReactNode;
}) {
  return (
    <>
      <div className="sheet-backdrop" onClick={onClose} />
      <div className="sheet">
        <div className="sheet-grab" />
        {(title || headerRight) && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 18px 12px', borderBottom: '0.5px solid var(--border)' }}>
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>{title}</h3>
            {headerRight}
          </div>
        )}
        <div style={{ padding: 16 }}>{children}</div>
      </div>
    </>
  );
}

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <p style={{ fontSize: 13, fontWeight: 400, color: 'var(--text-mut)', margin: '20px 4px 7px' }}>{children}</p>
  );
}
